/**
 * User settings definitions — single source of truth.
 * Add a new setting here; resolver and UI pick it up automatically.
 * { key, default, type }
 */
export const userSettingsDefs = [
    { key: 'language',                                default: 'en',   type: 'string' },
    { key: 'timeZone',                                default: 'Europe/Amsterdam', type: 'string' },
    { key: 'dateFormat',                              default: null,   type: 'string' },
    { key: 'contentPanel.bgMode',                     default: 'dark', type: 'string' },
    { key: 'contentPanel.autoOpenJInspector',         default: false,  type: 'bool'   },
    // ADDED — close JInspector on mouse leave; when false user must cancel or save explicitly
    { key: 'contentPanel.closeJInspectorOnLeave',     default: true,   type: 'bool'   },
    { key: 'contentPanel.chipDateTimeFormat',         default: null,   type: 'string' },
    { key: 'contentPanel.daypart.night',              default: 'Nacht',   type: 'string' },
    { key: 'contentPanel.daypart.morning',            default: 'Ochtend', type: 'string' },
    { key: 'contentPanel.daypart.afternoon',          default: 'Middag',  type: 'string' },
    { key: 'contentPanel.daypart.evening',            default: 'Avond',   type: 'string' },
    // ADDED — configurable start tab for dashboard; default yourdata
    { key: 'dashboard.startTab',                      default: 'yourdata', type: 'string' },
    // ADDED — when true, every tab switch overwrites dashboard.startTab with the newly
    // active tab (auto-remember). When false, dashboard.startTab is a fixed pin only
    // changeable via the Settings dropdown, tab clicks don't touch it.
    { key: 'dashboard.rememberLastTab',               default: true,   type: 'bool'   },
    // ADDED — search result page size, was hardcoded 25 in 4 places
    { key: 'search.pageSize',                         default: 25,     type: 'number' },
    // ADDED — body editor style note title; resolved from Jerny.StyleNotes topic
    { key: 'bodyEditor.styleNote',                    default: 'BodyEditorStyle - Dark', type: 'string' },
    // ADDED — CM6 theme key for JxCodeEditor consumers (CsCodeTemplateEditorDlg etc).
    // JxCodeEditor itself stays dumb — consumer resolves this and passes it in as a prop.
    { key: 'codeEditor.theme',                        default: 'dark', type: 'string' },
    // ADDED — tooltip on/off. JxTooltip resolves this directly (no per-instance
    // variation needed, so no prop-drilling per consumer).
    { key: 'tooltip.enabled',                         default: true,   type: 'bool'   },
    // ADDED — auto-hide delay in ms while hovering, so you're not stuck staring at a hint
    // you already know. "Tip Duration" in SettingsTab.
    { key: 'tooltip.durationMs',                      default: 1500,   type: 'number' },
    // ADDED — UmlWorkspace canvas grid-snap (see rk=3487ce01a43f4e1b9da49ee7a5756219),
    // also toggleable/settable directly from UmlCanvasToolbar.
    { key: 'umlWorkspace.snapToGrid',                  default: true,   type: 'bool'   },
    { key: 'umlWorkspace.gridSize',                    default: 20,     type: 'number' },
    // ADDED — toggle for thumbnail previews in the Load Uml Schema dialog (LoadUmlNoteRow)
    { key: 'umlWorkspace.showPreviewInLoadDlg',        default: true,   type: 'bool'   },
    // ADDED — verbose hover-debug-logging to OutputMsgDlg (cat 'Debug'), off by default (noisy)
    { key: 'umlWorkspace.logHoverMessages',            default: false,  type: 'bool'   },
    // ADDED — OutputMsgWidget cache size (rk=78df94b1b46f4f4489056720f58935d5). Generic
    // across features, hence 'msgWindow' prefix, not 'umlWorkspace'.
    { key: 'msgWindow.cacheSize',                      default: 300,    type: 'number' },
    // ADDED — msgWindow.dateTimeFormat, moment.js format string for OutputMsgDlg rows, own setting so it doesn't
    // depend on contentPanel.chipDateTimeFormat (different UI, different needs — log rows
    // want a compact time-only default).
    { key: 'msgWindow.dateTimeFormat',                 default: 'HH:mm:ss', type: 'string' },
    // ADDED — UmlWorkspace Export Image dialog (UI/UmlCanvas/ExportImage/UmlExportImageDlg.jsx):
    // canvas size/padding/background for the exported PNG. No SettingsTab section for these —
    // ideal export size/padding differs per schema, so the dialog itself is the only place to
    // change them; persisted per-user just so the last-used values survive the session.
    { key: 'umlWorkspace.exportWidth',                 default: 1920,   type: 'number' },
    { key: 'umlWorkspace.exportHeight',                default: 1080,   type: 'number' },
    { key: 'umlWorkspace.exportPaddingTop',            default: 0,      type: 'number' },
    { key: 'umlWorkspace.exportBackgroundColor',       default: '#1c2b3f', type: 'string' },
    { key: 'umlWorkspace.exportTransparent',           default: false,  type: 'bool'   },
];
